import ActionTypes from './constants';
import { ContainerState, ContainerActions } from './types';

// The initial state of the App
export const initialState: ContainerState = {
  visibility: true,
  userInSession: false,
  userName: '',
  redirectUrl: '',
};

// Take this container's state (as a slice of root state), this container's actions and return new state
function appDrawerReducer(
  state: ContainerState = initialState,
  action: ContainerActions,
): ContainerState {
  switch (action.type) {
    case ActionTypes.CHANGE_APP_DRAWER_VISIBILITY:
      return {
        ...state,
        visibility: action.payload,
      };
    case ActionTypes.CHANGE_USER_IN_SESSION:
      return {
        ...state,
        userInSession: action.payload,
      };
    case ActionTypes.CHANGE_USER_NAME:
      return {
        ...state,
        userName: action.payload,
      };
    case ActionTypes.CHANGE_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload,
      };
    default:
      return state;
  }
}

export default appDrawerReducer;
